export default "__VITE_ASSET__C_sbTAdr__"